import { Container, Row, Col } from "react-bootstrap";
import styles from "./header.module.scss";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import useScreenSize from "../../hooks/useScreenSize";
import ArticleCard from "../../components/tax-updates/ArticleCard";
// import image1 from "/images/articles/artc_1_img.jpg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect, useState, useCallback } from "react";
import useLang from "hooks/useLang";

import axios from "axios";
// import useLang from "hooks/useLang";

const createPairs = (inputList) => {
  if (inputList.length % 2 !== 0) {
    inputList.push(null);
  }
  const result = [];
  for (let i = 0; i < inputList.length; i += 2) {
    const pair = inputList.slice(i, i + 2);
    result.push(pair);
  }
  return result;
};

export const TaxUpdateCardCarousel = (props) => {
  const { articles } = props;
  const { width, breakpoints } = useScreenSize();
  return (
    <Swiper
      className="hcarousel p-1"
      allowTouchMove={true}
      slidesPerView={width < breakpoints.sm ? 2 : 3}
      spaceBetween={5}
      pagination={true}
      navigation={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      loop={true}
      modules={[Autoplay, Navigation, Pagination]}
    >
      {createPairs(articles).map(([props1, props2]) => (
        <SwiperSlide>
          <ArticleCard {...props1} />
          {props2 == null ? <div /> : <ArticleCard {...props2} />}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const TaxUpdatesHeader = () => {
  const { lang } = useLang();
  const [banner, setBanner] = useState({})
  const [articles, setArticles] = useState([]);
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("authToken")}`, // Add Bearer prefix
      "Content-Type": "application/json"
    }
  });
  const fetchArticleDetail = useCallback(async (params)  => {
    const queryParams = new URLSearchParams();
    queryParams.set('order', 'DESC')
    const response = await client.get(`/be/api/v1/front-end/articles/getList?${queryParams}`);
    const {articles: data} = response.data;
    const bannerArticle = data.shift();
    
    setBanner(bannerArticle)
    setArticles(data);
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
    fetchArticleDetail();
  }, [])

  return (
    <section className={styles.container}>
      <Container id="tax-updates-title" className={styles.title}>{lang.tax_updates.section_title}</Container>
      <Container className={["container", styles.starred].join(" ")}>
        <Row className="justify-content-center">
          <section>
            <Container>
              <Row
                // style={{ flexDirection: "row-reverse" }}
                className="align-items-center"
              >

                <Col lg={6}>
                  <img
                    src={`${process.env.REACT_APP_API_HOST}${banner.cardImage}`}
                    alt=""
                    className="fill-available our-services-home-img"
                  />
                </Col>
                <Col lg={6}>
                  <h3 className={styles.title}>{banner.cardTitle}</h3>
                  {/* <h3 className={styles.title}>asdasdasd</h3> */}
                  <p>
                    {banner.cardText}
                    {/* asdasd12312312312321 */}
                  </p>
                  <Link to={`/tax-updates/detail?id=${banner.id}`}>
                  {/* <Link to="/tax-updates/detail?type=first"> */}
                    <p className="read-more">
                      {lang.component.read_more_button}<i className="uil uil-arrow-right" />
                    </p>
                  </Link>
                </Col>
              </Row>
            </Container>
          </section>
        </Row>
      </Container>
      <Container className={styles.contents}>
        <h3 className={styles.title}>{lang.tax_updates.recent_articles}</h3>
        <p className="mb-4 text-muted">{lang.tax_updates.recent_articles_detail}</p>
        <TaxUpdateCardCarousel
          articles={articles}
        />
      </Container>
    </section>
  );
};

export default TaxUpdatesHeader;
